export type CameraError = 'denied' | 'inUse' | 'none';

function errorName(err: unknown): string {
  if (typeof err === 'object' && err !== null && 'name' in err) {
    return String(err.name);
  }
  return '';
}

export function mapMediaError(err: unknown, deviceCount: number): CameraError {
  if (deviceCount === 0) return 'none';
  const name = errorName(err);
  if (name === 'NotAllowedError' || name === 'SecurityError') return 'denied';
  if (name === 'NotFoundError' || name === 'OverconstrainedError')
    return 'none';
  return 'inUse';
}

export interface CameraSelectItem {
  value: string;
  label: string;
}

export function toCameraSelectItems(
  devices: MediaDeviceInfo[],
  genericLabel: string
): CameraSelectItem[] {
  return devices.map((device) => ({
    value: device.deviceId,
    label: device.label || genericLabel,
  }));
}
